import { render } from "./TagEditView.vue?vue&type=template&id=11e496b0&scoped=true"
import script from "./TagEditView.vue?vue&type=script&lang=js"
export * from "./TagEditView.vue?vue&type=script&lang=js"

import "./TagEditView.vue?vue&type=style&index=0&id=11e496b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e496b0"]])

export default __exports__